import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import OverviewServices from "./Overview.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getOverview = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OVERVIEW,
      payload: true,
    });
    const resp = await OverviewServices.getOverview(filters);
    dispatch({
      type: actions.GET_OVERVIEW,
      payload: {
        overviews: resp.data,
      },
    });
    dispatch({
      type: actions.OVERVIEW_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.OVERVIEW_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OVERVIEW,
      payload: false,
    });
  }
};

export const getOverviewById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OVERVIEW_BY_ID,
      payload: true,
    });
    const resp = await OverviewServices.getOverviewById(id);
    dispatch({
      type: actions.GET_OVERVIEW_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.OVERVIEW_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.OVERVIEW_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OVERVIEW_BY_ID,
      payload: false,
    });
  }
};

export const saveOverview =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_OVERVIEW,
        payload: true,
      });
      const resp = await OverviewServices.saveOverview(data);
      const { overviews, overviewsLength } = getState().overview;
      dispatch({
        type: actions.GET_OVERVIEW,
        payload: {
          overviews: [...overviews, resp.data],
          overviewsLength: overviewsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_OVERVIEW,
        payload: false,
      });
    }
  };

export const editOverview =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_OVERVIEW,
        payload: true,
      });
      const resp = await OverviewServices.editOverview(id, data);
      const { overviews, overviewsLength } = getState().overview;
      overviews[index] = resp.data;
      dispatch({
        type: actions.GET_OVERVIEW,
        payload: {
          overviews: overviews,
          overviewsLength: overviewsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_OVERVIEW,
        payload: false,
      });
    }
  };

export const deleteOverview = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_OVERVIEW,
      payload: true,
    });
    await OverviewServices.deleteOverview(id);
    const { overviews, overviewsLength } = getState().overview;
    overviews.splice(index, 1);
    dispatch({
      type: actions.GET_OVERVIEW,
      payload: {
        overviews: overviews,
        overviewsLength: overviewsLength - 1,
      },
    });
    dispatch({
      type: actions.OVERVIEW_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.OVERVIEW_FAIL,
    //   payload: message,
    // });
    toastr.error(message);
  } finally {
    dispatch({
      type: actions.LOADING_OVERVIEW,
      payload: false,
    });
  }
};
